import { RouteObject } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import { RequireAuth } from "@/auth/require-auth";
import { RequireModule } from "@/auth/require-module";
import DashboardPage from "@/pages/home/page";
import ClientesPage from "@/pages/clientes/page";
import ClienteDetallePage from "@/pages/clientes/detalle/page";
import FacturacionPage from "@/pages/facturacion/page";
import OperacionesPage from "@/pages/operaciones/page";
import AdministracionPage from "@/pages/administracion/page";
import BodegaPage from "@/pages/bodega/page";
import ReportesPage from "@/pages/reportes/page";
import LecturasPeriodoPage from "@/pages/lecturas-periodo/page";
import SeguimientoTerrenoPage from "@/pages/seguimiento-terreno/page";
import ConfiguracionPage from "@/pages/configuracion/page";
import ControlLecturasPage from "@/pages/control-lecturas/page";
import NotificacionesPage from "@/pages/notificaciones/page";
import ContratosPage from "@/pages/contratos/page";
import CajaChicaPage from "@/pages/cajaChica/page";
import RegistrarPagoPage from "@/pages/registrarPago/page";
import PrestamosPage from "@/pages/prestamos/page";
import DocumentacionPage from "@/pages/documentacion/page";
import ModuloTerrenoPage from "@/pages/moduloTerreno/page";
import ImportarLecturasPage from "@/pages/importar-lecturas/page";
import CortesServicioPage from "@/pages/cortes/page";
import LecturasPage from "@/pages/lecturas/page";
import GastosVariablesPage from "@/pages/gastos-variables/page";
import AuditoriaPage from "@/pages/auditoria/page";
import LoginPage from "@/pages/login/page";
import NotFound from "@/pages/NotFound";

function withModule(moduleCode: string | string[], element: React.ReactNode): React.ReactNode {
  return <RequireModule moduleCode={moduleCode}>{element}</RequireModule>;
}

const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: withModule("dashboard", <DashboardPage />) },
      { path: "clientes", element: withModule("clientes", <ClientesPage />) },
      { path: "clientes/:id", element: withModule("clientes", <ClienteDetallePage />) },
      { path: "facturacion", element: withModule("facturacion", <FacturacionPage />) },
      { path: "operaciones", element: withModule("operaciones", <OperacionesPage />) },
      { path: "administracion", element: withModule(["facturacion", "prestamos", "documentacion_apr"], <AdministracionPage />) },
      { path: "bodega", element: withModule("bodega", <BodegaPage />) },
      { path: "reportes", element: withModule("reportes", <ReportesPage />) },
      { path: "lecturas-periodo", element: withModule("reportes", <LecturasPeriodoPage />) },
      { path: "configuracion", element: withModule("configuracion", <ConfiguracionPage />) },
      { path: "lecturas", element: withModule("control_lecturas", <LecturasPage />) },
      { path: "control-lecturas", element: withModule("control_lecturas", <ControlLecturasPage />) },
      { path: "seguimiento-terreno", element: withModule("reportes", <SeguimientoTerrenoPage />) },
      { path: "notificaciones", element: withModule("dashboard", <NotificacionesPage />) },
      { path: "contratos", element: withModule("clientes", <ContratosPage />) },
      { path: "caja-chica", element: withModule("facturacion", <CajaChicaPage />) },
      { path: "registrar-pago", element: withModule("facturacion", <RegistrarPagoPage />) },
      { path: "prestamos", element: withModule("prestamos", <PrestamosPage />) },
      { path: "documentacion-apr", element: withModule("documentacion_apr", <DocumentacionPage />) },
      { path: "modulo-terreno", element: withModule("modulo_terreno", <ModuloTerrenoPage />) },
      { path: "importar-lecturas", element: withModule("control_lecturas", <ImportarLecturasPage />) },
      { path: "cortes-servicio", element: withModule("facturacion", <CortesServicioPage />) },
      { path: "gastos-variables", element: withModule("facturacion", <GastosVariablesPage />) },
      { path: "auditoria", element: withModule("reportes", <AuditoriaPage />) },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
